import { render } from "./DatabaseSyncLogsDetails.vue?vue&type=template&id=477a4510"
import script from "./DatabaseSyncLogsDetails.vue?vue&type=script&lang=js"
export * from "./DatabaseSyncLogsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__